import { render, staticRenderFns } from "./gather-money.vue?vue&type=template&id=1ecaebdf&scoped=true"
import script from "./gather-money.vue?vue&type=script&lang=js"
export * from "./gather-money.vue?vue&type=script&lang=js"
import style0 from "./gather-money.vue?vue&type=style&index=0&id=1ecaebdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecaebdf",
  null
  
)

export default component.exports